import type { LucideIcon } from 'lucide-react';
import { supportedLocales, useI18n, type I18nKey } from '../i18n';

export type NavItem = {
  id: string;
  labelKey: I18nKey;
  icon: LucideIcon;
  path: string;
};

type ConsoleShellProps = {
  navItems: NavItem[];
  activeNav: string;
  onLogout?: () => void;
  children: React.ReactNode;
};

export function ConsoleShell({ navItems, activeNav, onLogout, children }: ConsoleShellProps) {
  const { locale, setLocale, t } = useI18n();

  return (
    <div className="console-shell">
      <aside className="sidebar">
        <div className="brand">
          <span className="brand-mark">cc</span>
          <div>
            <strong>{t('app.title')}</strong>
            <small>{t('app.subtitle')}</small>
          </div>
        </div>
        <nav className="sidebar-nav" aria-label={t('app.navigation')}>
          {navItems.map(item => {
            const Icon = item.icon;
            return (
              <a key={item.id} className={item.id === activeNav ? 'nav-link active' : 'nav-link'} href={item.path}>
                <Icon size={18} />
                <span>{t(item.labelKey)}</span>
              </a>
            );
          })}
        </nav>
        <div className="language-switch" aria-label={t('app.language')}>
          {supportedLocales.map(option => (
            <button
              key={option.code}
              aria-pressed={option.code === locale}
              className={option.code === locale ? 'language-option active' : 'language-option'}
              type="button"
              onClick={() => setLocale(option.code)}
            >
              {option.shortLabel}
            </button>
          ))}
        </div>
        {onLogout ? <button className="btn btn-compact sidebar-logout" type="button" onClick={onLogout}>{t('app.logout')}</button> : null}
      </aside>
      <main className="main-panel">{children}</main>
    </div>
  );
}
